var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from 'react';
import { NodeHoverState } from '../node/Node';
import { DiagramObjectType } from '../types';
var findNodeById = function (id, nodes) {
    return !id ? undefined : nodes.find(function (node) { return node.id === id; });
};
export var useHoverNodesLogic = function (nodes, columns, expandedNodeIds) {
    var _a = useState([]), highlightedNodeIds = _a[0], setHighlightedNodeIds = _a[1];
    var getNodeHoverState = function (nodeId) {
        if (highlightedNodeIds.length === 0) {
            return NodeHoverState.NONE;
        }
        else {
            return highlightedNodeIds.includes(nodeId) ? NodeHoverState.HIGHLIGHTED : NodeHoverState.DIMMED;
        }
    };
    var onHoverNodeStart = function (hoveredNode, columnIndex) {
        if (!hoveredNode) {
            setHighlightedNodeIds([]);
        }
        var getUpstreamNodes = function (nodeId, colIndex) {
            if (colIndex < 1) {
                return [];
            }
            var upstreamNodeIds = [];
            columns[colIndex - 1]
                .filter(function (id) { return expandedNodeIds.includes(id); })
                .filter(function (id) { var _a; return (_a = findNodeById(id, nodes)) === null || _a === void 0 ? void 0 : _a.links.map(function (link) { return link.nodeId; }).includes(nodeId); })
                .forEach(function (upstreamNodeId) {
                upstreamNodeIds.push.apply(upstreamNodeIds, __spreadArray([upstreamNodeId], getUpstreamNodes(upstreamNodeId, colIndex - 1), false));
            });
            return upstreamNodeIds;
        };
        var getDownstreamNodes = function (nodeId) {
            if (!expandedNodeIds.includes(nodeId)) {
                return [];
            }
            var downStreamNodeIds = [];
            var node = findNodeById(nodeId, nodes);
            node === null || node === void 0 ? void 0 : node.links.map(function (link) { return link.nodeId; }).forEach(function (downStreamNodeId) {
                downStreamNodeIds.push.apply(downStreamNodeIds, __spreadArray([downStreamNodeId], getDownstreamNodes(downStreamNodeId), false));
            });
            return downStreamNodeIds;
        };
        if (hoveredNode) {
            setHighlightedNodeIds(__spreadArray(__spreadArray(__spreadArray([], getUpstreamNodes(hoveredNode.id, columnIndex), true), [
                hoveredNode.id
            ], false), getDownstreamNodes(hoveredNode.id), true));
        }
    };
    var onHoverNodeStop = function (hoveredNode, columnIndex) {
        var parentNode = nodes.find(function (node) {
            return node.id === (hoveredNode === null || hoveredNode === void 0 ? void 0 : hoveredNode.groupParentNode) && node.type !== DiagramObjectType.GROUP;
        });
        onHoverNodeStart(parentNode, columnIndex);
    };
    return {
        highlightedNodeIds: highlightedNodeIds,
        getNodeHoverState: getNodeHoverState,
        onHoverNodeStart: onHoverNodeStart,
        onHoverNodeStop: onHoverNodeStop,
    };
};
//# sourceMappingURL=hoverNodes.js.map